import React from 'react';
import classNames from 'classnames';

interface ServiceGridProps {
  /** Services to display in a grid. */
  children: React.ReactNode;
  /** CSS class name. */
  className?: string;
  /** CSS class name only applied to the children div. */
  childrenClassName?: string;
  /** Headline for the ServiceGrid. */
  header?: React.ReactNode;
}

/** Displays a grid of given Services. */
const ServiceGrid = ({
  children,
  childrenClassName,
  className,
  header,
}: ServiceGridProps) => {
  return (
    <div className={classNames(className, 'ce ce-service-grid')}>
      {header}
      <div className={classNames(childrenClassName, 'ce-service-grid-wrapper')}>
        {children}
      </div>
    </div>
  );
};

ServiceGrid.defaultProps = {
  childrenClassName: null,
  className: null,
  header: null,
};

export default ServiceGrid;
